import styled from 'styled-components';

export const AlignSelfEnd = styled.div`
  align-self: end;
  margin-right: 10%;
`;
